import React, { useState, useEffect } from 'react';
import { Badge } from '../ui/Badge';
// Seam API imports removed — Seam integration disabled

// Stub function to prevent runtime errors
const listLockEvents = async (deviceId: string, limit: number) => [];

const EVENT_LABELS: Record<string, { label: string; color: string }> = {
  'lock.locked': { label: 'Locked', color: 'green' },
  'lock.unlocked': { label: 'Unlocked', color: 'yellow' },
  'access_code.set': { label: 'Code Set', color: 'blue' },
  'access_code.deleted': { label: 'Code Deleted', color: 'red' },
  'access_code.used': { label: 'Code Used', color: 'purple' },
  'device.connected': { label: 'Connected', color: 'green' },
  'device.disconnected': { label: 'Disconnected', color: 'red' },
  'device.low_battery': { label: 'Low Battery', color: 'yellow' },
};

interface Props {
  deviceId: string;
}

export const LockEventLog: React.FC<Props> = ({ deviceId }) => {
  const [events, setEvents] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEvents = async () => {
      setLoading(true);
      try {
        const result = await listLockEvents(deviceId, 50);
        setEvents(result);
      } catch (e: any) {
        console.error('Failed to load lock events:', e);
      } finally {
        setLoading(false);
      }
    };
    fetchEvents();
  }, [deviceId]);

  if (loading) return <div className="text-center py-4 text-gray-400">Loading events...</div>;

  if (events.length === 0) return <div className="text-center py-6 text-gray-400 text-sm">No events recorded yet.</div>;

  return (
    <div className="space-y-2 max-h-80 overflow-y-auto">
      {events.map((evt: any) => {
        const info = EVENT_LABELS[evt.event_type] || { label: evt.event_type, color: 'gray' };
        return (
          <div key={evt.event_id} className="flex items-start gap-3 p-3 rounded-lg border border-gray-100 hover:bg-gray-50">
            <div className="flex-shrink-0 mt-0.5">
              <Badge color={info.color}>{info.label}</Badge>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-gray-900">{evt.event_type.replace(/\./g, ' \u2192 ')}</p>
              {evt.method && <p className="text-xs text-gray-500">Method: {evt.method}</p>}
            </div>
            <div className="flex-shrink-0 text-xs text-gray-400">
              {evt.occurred_at ? new Date(evt.occurred_at).toLocaleString() : ''}
            </div>
          </div>
        );
      })}
    </div>
  );
};
